import { createStore } from 'vuex'
import blogCart from './modules/blogCart'

export default createStore({
  modules: {
    blogCart,
  }
})
